import _ from 'lodash';
import { displayToServerDate, displayToServerTimeSlot } from 'app/lib/format';
import { getData } from 'app/lib/serverDataCache';
import { serverKeyMap } from './serverToClientMap';
import invert from 'app/lib/invert';

const clientKeyMap = invert(serverKeyMap);
const exclude = ['units', 'timeslot', 'status'];

const booleanToInt = (value) => (
    value ? 1 : 0
);
const mapBooleansToInt = (values) => {
    let _values = {};

    _.each(values, (value, key) => {
        if (_.isObject(value)) {
            _values[key] = mapBooleansToInt(value);
        }
        else if (_.isBoolean(value)) {
            _values[key] = booleanToInt(value);
        } else {
            _values[key] = value;
        }
    });

    return _values;
};

export const clientValueMap = {
    slotEta: (value) => displayToServerDate(value),
    delay: (value) => value ? 1 : 0,
    empty: (value) => value === '1' ? 1 : 0,
    rid: (value) => value ? 1 : 0,
    unitKind: (value) => getData('unitKind', value, 'code'),
    dim: (value) => getData('dim', value, 'desc'),
    licensePlate: (value) => value === '' ? null : value,
    chassisPlate: (value) => value === '' ? null : value,
    regDate: (value) => value && displayToServerDate(value),
    lq: (value) => !value ? 0 : 1,
    maritime: (value) => !value ? 0 : 1,
    environment: (value) => !value ? 0 : 1,
    waste: (value) => !value ? 0 : 1,
    packagingUnity: (value) => value && value.trim()
};

export const clientVisitToServerMap = (visit, isUpdate) => {
    let  _visit = {};

    if (visit.timeslot) {
        let fromAndTo = displayToServerTimeSlot(visit.timeslot);
        _visit.slotFrom = fromAndTo[0];
        _visit.slotTo = fromAndTo[1];
    }

    _.each(visit, function(value, key) {
        key = clientKeyMap[key] || key;
        if (clientValueMap[key]) {
            value = clientValueMap[key](value);
        }
        if (exclude.indexOf(key) === -1) {
            _visit[key] = value;
        }
    });

    if (isUpdate) {
        delete _visit.ownerTransId;
    }
    
    return _visit;
};

export const clientUnitToServerMap = (unit) => {
    let _unit = {};

    _.each(unit, function(value, key) {
        key = clientKeyMap[key] || key;
        if (clientValueMap[key]) {
            value = clientValueMap[key](value);
        }
        if (exclude.indexOf(key) === -1) {
            _unit[key] = value;
        }
    });

    delete _unit.good;
    delete _unit.doc;

    return _unit;
};

export const clientGoodToServerMap = (good) => {
    let _good = {};

    _.each(good, function (value, key) {
        if (_.isObject(value)) {
            _good[key] = clientGoodToServerMap(value);
        } else {
            if (clientValueMap[key]) {
                value = clientValueMap[key](value);
            }
            _good[key] = value;
        }
    });

    _good = mapBooleansToInt(_good);

    if (_good.hasOwnProperty('hzd') || _good.hasOwnProperty('hzdData')) {
        if (_good.hzd && _good.hzdData.hzdId) {
            _good.hzdData.originalHzdId = _good.hzdData.hzdId;
            delete _good.hzdData.hzdId;
        } else if (!_good.hzd) {
            delete _good.hzdData;
        }
    }

    delete _good.open;

    return _good;
};


export const clientDocToServerMap = (doc) => {
    let _doc = {};

    _.each(doc, function (value, key) {
        if (clientValueMap[key]) {
            value = clientValueMap[key](value);
        }
        _doc[key] = value;
    });

    delete _doc.open;

    return _doc;
};